window.toggleSingleHeaderDropdown = function (type, trigger) {
  const targetWrapper = trigger.closest(type === 'currency' ? '.custom-currency-wrapper' : '.custom-language-wrapper');
  const allWrappers = document.querySelectorAll('.custom-currency-wrapper, .custom-language-wrapper');

  allWrappers.forEach((wrapper) => {
    const isTarget = wrapper === targetWrapper;
    const button = wrapper.querySelector(type === 'currency' ? '.custom-currency-trigger' : '.custom-language-trigger');

    if (!isTarget) {
      wrapper.classList.remove('is-open');
      if (button) button.setAttribute('aria-expanded', 'false');
      return;
    }

    const shouldOpen = !wrapper.classList.contains('is-open');
    wrapper.classList.toggle('is-open', shouldOpen);
    if (button) button.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
  });
};

document.addEventListener('DOMContentLoaded', function () {
  // 1. Mobile Sidebar Toggle
  const toggleBtn = document.querySelector('.sdusa-mobile-toggle');
  const closeBtn = document.getElementById('sdusaSidebarClose');
  const sidebar = document.getElementById('sdusaMobileSidebar');
  const overlay = document.getElementById('sdusaSidebarOverlay');

  function openSidebar() {
    if (sidebar && overlay) {
      sidebar.classList.add('active');
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeSidebar() {
    if (sidebar && overlay) {
      sidebar.classList.remove('active');
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  if (toggleBtn) toggleBtn.addEventListener('click', openSidebar);
  if (closeBtn) closeBtn.addEventListener('click', closeSidebar);
  if (overlay) overlay.addEventListener('click', closeSidebar);

  // 2. Predictive Search Functionality
  const input = document.querySelector('[data-js-custom-predictive-input]');
  const resultsContainer = document.querySelector('[data-js-predictive-results-container]');

  if (!input || !resultsContainer) return;

  let debounceTimer;

  input.addEventListener('input', function () {
    const query = this.value.trim();
    clearTimeout(debounceTimer);

    if (query.length < 2) {
      resultsContainer.innerHTML = '';
      resultsContainer.style.display = 'none';
      return;
    }

    debounceTimer = setTimeout(() => {
      const requestUrl = `${routes.predictive_search_url}?q=${encodeURIComponent(
        query
      )}&section_id=predictive-search`;

      fetch(requestUrl)
        .then((response) => {
          if (!response.ok) throw new Error('Network response error');
          return response.text();
        })
        .then((html) => {
          resultsContainer.innerHTML = html;
          resultsContainer.style.display = 'block';

          // Initialize Swiper with Resize Observers
          if (window.Swiper && resultsContainer.querySelector('.swiper-container')) {
            const swiperInstance = new Swiper(resultsContainer.querySelector('.swiper-container'), {
              slidesPerView: 1.2,
              spaceBetween: 10,
              observer: true,
              observeParents: true,
              resizeObserver: true,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },
              breakpoints: {
                480: { slidesPerView: 2, spaceBetween: 12 },
                768: { slidesPerView: 3, spaceBetween: 15 },
                1200: { slidesPerView: 4, spaceBetween: 15 },
              },
            });

            setTimeout(() => {
              swiperInstance.update();
            }, 100);
          }
        })
        .catch((error) => console.error('Error fetching predictive search:', error));
    }, 300);
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.sdusa-search-container') && !e.target.closest('.sdusa-predictive-search-results-modal')) {
      resultsContainer.style.display = 'none';
    }
  });

  // 3. Close language and currency dropdowns when clicking outside
  document.addEventListener('click', function(event) {
    // Language Dropdown
    document.querySelectorAll('.custom-language-wrapper').forEach(wrapper => {
      if (!wrapper.contains(event.target)) {
        wrapper.classList.remove('is-open');
        const button = wrapper.querySelector('.custom-language-trigger');
        if (button) button.setAttribute('aria-expanded', 'false');
      }
    });

    // Currency Dropdown
    document.querySelectorAll('.custom-currency-wrapper').forEach(wrapper => {
      if (!wrapper.contains(event.target)) {
        wrapper.classList.remove('is-open');
        const button = wrapper.querySelector('.custom-currency-trigger');
        if (button) button.setAttribute('aria-expanded', 'false');
      }
    });
  });

  // 4. Append Top Bar Menu Links to Mobile Navigation Drawer
  function injectTopBarLinksToMobileMenu() {
    const template = document.getElementById('sdusa-mobile-topbar-template');
    if (!template) return;

    const navLevel1 = document.querySelector('#dropdnMenuTabPopup ul.nav-level-1');
    if (!navLevel1) return;

    // Avoid duplicate insertion
    if (navLevel1.querySelector('.sdusa-top-menu-item')) return;

    const clone = template.content.cloneNode(true);
    navLevel1.appendChild(clone);

    const slideMenu = navLevel1.closest('slide-menu');
    if (slideMenu) {
      navLevel1.querySelectorAll('.sdusa-top-menu-item a').forEach(function (link) {
        link.addEventListener('click', slideMenu.onLinkClick.bind(slideMenu));
      });

      if (typeof slideMenu.labelWidth === 'function') {
        slideMenu.labelWidth();
      }

      if (typeof slideMenu.updateHeight === 'function') {
        slideMenu.updateHeight();
        setTimeout(function () {
          slideMenu.updateHeight();
        }, 100);
      }
    }
  }

  const ajaxContainer = document.querySelector('#dropdnMenuTabPopup [data-ajax-container]');
  if (ajaxContainer) {
    const observer = new MutationObserver(function () {
      injectTopBarLinksToMobileMenu();
    });
    observer.observe(ajaxContainer, { childList: true, subtree: true });
  }

  const burgerPopup = document.querySelector('menu-popup[data-selector="#dropdnMenuTabPopup"]');
  if (burgerPopup) {
    burgerPopup.addEventListener('click', function () {
      setTimeout(injectTopBarLinksToMobileMenu, 100);
      setTimeout(injectTopBarLinksToMobileMenu, 350);
      setTimeout(injectTopBarLinksToMobileMenu, 700);
    });
  }
});

// 4. Trustpilot widget script — completely asynchronous, never blocks page load/render
(function () {
  var loaded = false;
  function loadTrustpilot() {
    if (loaded) return;
    loaded = true;

    // Clean up all trigger listeners
    ['scroll', 'touchstart', 'click', 'keydown'].forEach(function (evt) {
      window.removeEventListener(evt, loadTrustpilot, { passive: true });
    });

    function initWidgets() {
      var widgets = document.querySelectorAll('.trustpilot-widget');
      if (window.Trustpilot) {
        widgets.forEach(function (widget) {
          try {
            window.Trustpilot.loadFromElement(widget);
          } catch (e) {}
        });
      }
    }

    if (window.Trustpilot) {
      initWidgets();
      return;
    }

    var existing = document.querySelector('script[src*="widget.trustpilot.com"]');
    if (existing) {
      existing.addEventListener('load', initWidgets, { once: true });
      return;
    }

    var s = document.createElement('script');
    s.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    s.async = true;
    s.addEventListener('load', initWidgets, { once: true });
    document.body.appendChild(s);
  }

  // Only listen AFTER page is completely finished loading
  function scheduleTrustpilot() {
    // 1. Load immediately on real user interaction (scroll, touch, click)
    ['scroll', 'touchstart', 'click', 'keydown'].forEach(function (evt) {
      window.addEventListener(evt, loadTrustpilot, { once: true, passive: true });
    });

    // 2. Fallback: If user does nothing, load after 4 seconds of idle time without blocking LCP
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(function () {
        setTimeout(loadTrustpilot, 4000);
      }, { timeout: 6000 });
    } else {
      setTimeout(loadTrustpilot, 4000);
    }
  }

  if (document.readyState === 'complete') {
    scheduleTrustpilot();
  } else {
    window.addEventListener('load', scheduleTrustpilot, { once: true });
  }
})();